export type LanguagePrimitives = { id: string; name: string };

export class Language {
  constructor(public readonly id: string, public readonly name: string) {}

  static fromPrimitives(primitives: LanguagePrimitives) {
    return new this(primitives.id, primitives.name);
  }

  toPrimitives(): LanguagePrimitives {
    return {
      id: this.id,
      name: this.name,
    };
  }
}
